<template lang="pug">
    .selector-item(:class='curPartID' ref='selectorItem')
        .selector-item_container
            //- .selector-item_decor.selector-item_decor__cigarettes.js-bgdecor(ref='cigarettes' v-if='curPartID === "zonehardened"')
            //-     img(src='@/assets/img/selector/zonehardened/cigarettes.jpg')
            //- .selector-item_decor.selector-item_decor__green-box.js-bgdecor(ref='greenBox' v-if='curPartID === "zonehardened"')
            //-     img(src='@/assets/img/selector/zonehardened/green-box.png')

            .selector-item_decor.selector-item_decor__lamp(ref='lamp' v-if='curPartID === "zonehardened"')
                img(src='@/assets/img/selector/zonehardened/lamp.png')
                .selector-item_decor__lamp-light(ref='light')
            .selector-item_decor.selector-item_decor__cig-case.js-bgdecor(ref='cigcase' v-if='curPartID === "zonehardened"')
                img(src='@/assets/img/selector/zonehardened/cig-case.png')
                .selector-item_decor.selector-item_decor__lighter.js-bgdecor(ref='lighter')
                    img(src='@/assets/img/selector/zonehardened/lighter.png')
            //-.selector-item_decor.selector-item_decor__ashtray.js-bgdecor
                img(src='@/assets/img/timeline/ashtray.png')
                //-.selector-item_decor.selector-item_decor__cigarette.js-bgdecor
                    img(src='@/assets/img/timeline/cigarette.png')
                
            //- .selector-item_decor.selector-item_decor__wristwatch.js-bgdecor(ref='wristwatch'  v-if='curPartID === "zonehardened"')
            //-     img(src='@/assets/img/selector/zonehardened/wristwatch.png')
                      
            .selector-item_count
                span.selector-item_count-zero.js-counted 0
                span.selector-item_count-number.js-counted(v-html='curPartIndex + 1', ref='number')
            router-link.selector-item_title(:to='`/${curPartID}/menu`' :class='{"unAvailable": !curPart.isAvailable}')
                //- span.selector-item_title-row(v-for='row in curPartName')
                //-     span(v-html='row' ref='titleRow')
                span.selector-item_title-row(v-for='row in curPartName')
                    span.selector-item_title-word(v-for='word in row.split(" ")')
                        span.selector-item_title-letter-wrp(v-for='letter in word')
                            span.selector-item_title-letter(v-html='letter' ref='letter')
            .selector-item__description
                p.selector-item__description-par(v-for='par in curPart.description')
                    span.selector-item__description-letter(v-if='curPart.description' v-for='letter in par.split(" ")' ref='description' v-html='letter')
            .selector-item_btns(ref='btns')
                router-link.selector-item_btn.selector-item_btn__prev(
                    v-if='prevPart'
                    :to='`/${prevPart.id}`'
                    v-html='curPart.arrows.prev'
                    )
                router-link.selector-item_btn.selector-item_btn__next(
                    v-if='curPart.arrows.next'
                    :to='`/${nextPart.id}`'
                    v-html='curPart.arrows.next'
                    )


        //-.section
            .section__image-wrapper
                .section__image-grid-container
                    .section__image-container
                        img.section__image(
                            :src='require(`@/assets/img/selector/${curPartID}.jpg`)'
                        )
            .section__text-btn-cnt
                router-link.section__text-wrapper(
                    :to='`${curPartID}/menu`'
                    )
                    span.section__text-block(
                        v-for='(text, blockIndex) in curPart.textblock'
                        )

                        span.section__text(
                            v-html='text'
                        )
                        span.section__text--white(
                            v-html='text'
                        )
                        br
                .btn-part-wrp(ref='btnPart')
                    router-link.btn-part.btn-part_prev(
                        v-if='prevPart'
                        :to='`/${prevPart.id}`'
                        v-html='curPart.arrows.prev'
                        )
                    router-link.btn-part.btn-part_next(
                        v-if='nextPart'
                        :to='`/${nextPart.id}`'
                        v-html='curPart.arrows.next'
                        )
</template>
<script>
import {gsap} from 'gsap';
import data from '@/assets/data/menu';
export default {
    data() {
        return {
            tl: null,
            curPartID: this.$route.params.part,
            data,
            scrollListener: null,
            isActivatedScroll: false
        };
    },
    props: {
        rootUpdating: Boolean
    },
    computed: {
        curPartIndex() {
            return data.parts.indexOf(data.parts.find(item => item.id === this.curPartID));
        },
        curPart() {
            return data.parts[this.curPartIndex];
        },
        curPartName() {
            return data.parts[this.curPartIndex].textblock;
        }
    },
    watch: {
        $route(to) {
            this.curPartID = to.params.part;
            this.setPrevAndNextArticle();
        },
        rootUpdating(to) {
            if (to) this.hideBlock();
        }
    },
    created() {
        this.setPrevAndNextArticle();
    },
    mounted() {
        this.createAnimation();
        window.addEventListener('scroll', this.changeURL);
        this.createLightAnim();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.changeURL);
        this.destroyAnimation();
    },
    updated() {
        this.createAnimation();
        this.createLightAnim();
    },
    methods: {
        changeURL() {
            if (this.curPartID === 'zonehardened') {
                this.$router.push(`/${this.curPartID}/menu`);
                window.removeEventListener('scroll', this.changeURL);
            }
        },
        setPrevAndNextArticle() {
            let prevPartIndex = this.curPartIndex - 1,
                nextPartIndex = this.curPartIndex + 1;

            this.prevPart = prevPartIndex > -1 ? data.parts[prevPartIndex] : null;
            this.nextPart = nextPartIndex < data.parts.length ? data.parts[nextPartIndex] : null;
        },
        hideBlock() {
            if (this.timeline) this.timeline.kill();
            let bgdecor = this.$refs.selectorItem.querySelectorAll('.js-bgdecor');
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .fromTo(this.$refs.titleRow, {y: '0'}, {duration: 0.3, y: '-100%'}, 0)
                .fromTo(this.$refs.number, {y: '0'}, {duration: 0.2, y: '100%', stagger: {each: 0.1}}, 0.1)
                .fromTo(this.$refs.btns, {opacity: 1}, {duration: 0.1, opacity: 0}, 0.2)
                .fromTo(bgdecor, {opacity: 1}, {duration: 0.25, opacity: 0, stagger: {amount: 0.25}}, 0.6)
                .fromTo(this.$refs.selectorItem, {opacity: 1}, {duration: 1, opacity: 0}, 0);
            this.timeline.play();
        },
        createLightAnim() {
            this.lighttl = gsap.timeline({repeat: -1, yoyo: true});
            this.lighttl
                .set(this.$refs.light, {opacity: 0.4})
                .to(
                    this.$refs.light,
                    {
                        keyframes: [
                            {opacity: 0.4},
                            {duration: 0.1, opacity: 'random(0.1, 0.29)'},
                            {duration: 0.1, opacity: 'random(0.29, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.1, 0.29)'},
                            {duration: 0.1, opacity: 0.4}
                        ]
                    },
                    '2'
                )
                .to(
                    this.$refs.light,
                    {
                        keyframes: [
                            {opacity: 0.4},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.29, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.29, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 0}
                        ]
                    },
                    '+=2'
                )
                .to(
                    this.$refs.light,
                    {
                        keyframes: [
                            {opacity: 0},
                            {duration: 0.1, opacity: 'random(0.1, 0.2)'},
                            {duration: 0.1, opacity: 'random(0.29, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 0.2}
                        ]
                    },
                    '+=0.5'
                )
                .to(
                    this.$refs.light,
                    {
                        keyframes: [
                            {opacity: 0.2},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.29, 0.39)'},
                            {duration: 0.1, opacity: 'random(0.1, 0.39)'},
                            {duration: 0.1, opacity: 0.4}
                        ]
                    },
                    '+=2'
                );
        },
        createAnimation() {
            let counted = this.$refs.selectorItem.querySelectorAll('.js-counted'),
                bgdecor = this.$refs.selectorItem.querySelectorAll('.js-bgdecor'),
                letters = this.$refs.selectorItem.querySelectorAll('.selector-item__description-letter');
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.selectorItem, {opacity: 0})
                // .set(this.$refs.titleRow, {y: '100%'})
                .set(this.$refs.letter, {x: '-1em'})
                .set(this.$refs.btns, {opacity: 0})
                // .set(bgdecor, {opacity: 0}, 0)
                .set(this.$refs.number, {y: '-100%'})
                .set(letters, {opacity: 0})
                // .fromTo(this.$refs.letter, {x: '100%'}, {duration: 2, x: 0, stagger: {each: 0.05, grid: 'auto'}})
                .fromTo(this.$refs.selectorItem, {opacity: 0}, {duration: 1, opacity: 1}, 0)
                .fromTo(this.$refs.letter, {x: '-1em'}, {duration: 1.75, x: 0, ease: 'power1.inOut'}, 1)
                .to(bgdecor, {duration: 1, opacity: 1, stagger: {each: 0.2}}, 1)
                // .fromTo(this.$refs.titleRow, {y: '100%'}, {duration: 1, y: '0'}, 1.7)
                .to(counted, {duration: 0.5, y: '0%', stagger: {each: 0.3}}, 1.7)
                .fromTo(this.$refs.btns, {opacity: 0}, {duration: 1, opacity: 1}, 2)
                .fromTo(letters, {opacity: 0}, {duration: 0.01, opacity: 1, stagger: {amount: 2}}, 2.3);

            this.timeline.play();
        },

        destroyAnimation() {
            if (this.tl) this.tl.kill();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';

// @keyframes lighting {
//     0% {
//         opacity: 0.2;
//     }
//     50% {
//         opacity: 0.3;
//     }
//     100% {
//         opacity: 0.2;
//     }
// }

.selector-item {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    &.zonehardened {
        background: url('../assets/img/selector/zonehardened/bg.png') 50% 50% / cover no-repeat;
    }

    &.thronethieves {
        background: url('../assets/img/selector/underworldkings/bg.jpg') 50% 50% / cover no-repeat;
    }

    &_container {
        width: 100%;
        height: 100%;
        padding: 90px 88px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: relative;
        font-style: 12vw;

        @media screen and (--viewport-tablet) {
            padding: 30px var(--grid-column-mobile);
            justify-content: center;
        }
    }

    &_decor {
        z-index: 1;
        position: absolute;
        pointer-events: none;
        opacity: 0;

        img {
            display: block;
            width: 100%;
            height: auto;
        }

        &__lamp {
            width: calc(15vw + 15vh);
            // max-width: 334px;
            top: 0;
            right: 0;
            transform: translate(10%, -15%);
            z-index: 4;
            opacity: 1;

            &-light {
                width: 250%;
                padding-bottom: 250%;
                border-radius: 50%;
                background: radial-gradient(ellipse at center, #f1da36 0%, transparent 70%);
                opacity: 0.3;
                mix-blend-mode: multiply;
                position: absolute;
                top: 0;
                right: -20%;
                z-index: 1;
                // animation: lighting 2s ease-in 0s infinite;
            }
        }

        &__green-box {
            width: calc(20vw + 20vh);
            right: 30%;
            top: 0;
            transform: translateY(-20%);
            z-index: 2;

            @media screen and (--viewport-tablet) {
                right: auto;
                left: 0;
            }
        }

        &__cigarettes {
            width: calc(10vw + 10vh);
            left: 45%;
            bottom: 10%;
            z-index: 3;

            @media screen and (--viewport-tablet) {
                bottom: auto;
                top: 3%;
                left: 10%;
            }
        }

        &__cig-case {
            top: 0;
            left: 45%;
            width: calc(15vh + 15vw);
            transform: translateY(-30%);

            @media (--viewport-tablet) {
                left: 3%;
                width: calc(20vh + 15vw);
                transform: translateY(-30%) rotate(10deg);
            }
        }

        &__lighter {
            top: 0;
            left: 0;
            width: 100%;
        }

        &__wristwatch {
            bottom: 0;
            left: 20%;
            width: calc(13vh + 13vw);
            max-width: 250px;
            transform: translateY(30%);
        }

        &__ashtray {
            width: calc(20vw + 20vh);
            top: -10%;
            left: -8%;
            //transform: translateX(-12%) rotate(-20deg);
            z-index: 1;
            max-width: 500px;

            @media (--viewport-laptop) {
                display: none;
            }
        }

        &__cigarette {
            width: 100%;
            height: 100%;
            top: 0;
        }
    }

    &_count {
        font-family: var(--font-accent);
        font-weight: bold;
        font-size: 2.5vw;
        color: var(--color-white);
        width: 100%;
        z-index: 2;
        position: relative;
        overflow: hidden;

        @media (--viewport-tablet) {
            font-size: 1rem;
        }

        &-zero,
        &-number {
            display: inline-block;
        }

        &-zero {
            transform: translateY(-100%);
        }
    }

    &_title {
        font-family: var(--font-accent);
        font-weight: bold;
        font-size: 10.5vw;
        color: var(--color-white);
        line-height: 1;
        z-index: 5;
        position: relative;

        @media (--viewport-laptop) {
            font-size: 9vw;
        }

        &.unAvailable {
            pointer-events: none;
        }

        &-row {
            display: flex;
            justify-content: flex-start;
        }

        &-word {
            display: flex;
            justify-content: flex-start;
            padding-right: 0.5em;
        }

        &-letter-wrp {
            overflow: hidden;
        }

        &-letter {
            display: block;
        }
        // &-row {
        //     display: block;
        //     overflow: hidden;
        //     span {
        //         display: block;
        //         background: linear-gradient(90deg, rgb(255, 255, 255), rgb(255, 238, 180));
        //         -webkit-background-clip: text;
        //         -webkit-text-fill-color: transparent;
        //     }
        // }
    }

    &_btns {
        position: relative;
        z-index: 2;
        pointer-events: all;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        font-family: Podkova;
        font-weight: bold;
        font-size: 25px;
        margin-top: auto;

        @media screen and (--viewport-tablet) {
            margin-top: 2.5em;
            font-size: 15px;
        }
    }

    &_btn {
        color: #fff;
        text-align: left;
        padding: 1em 0;
        position: relative;

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 3);
        }

        @media (--viewport-mobile-s) {
            width: calc(var(--grid-column-mobile) * 4);
        }

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 5px;
            background: url('../assets/img/selector/btn-decor.svg') left center / contain no-repeat;

            @media (--viewport-tablet) {
                width: 100%;
            }
        }

        &__next {
            margin-left: auto;
        }

        &_announce {
            display: block;
            font-family: var(--font-main);
            font-size: 0.75rem;
            text-transform: uppercase;
            font-weight: bold;
            margin-top: 10px;

            @media (--viewport-tablet) {
                font-size: 9px;
            }
        }
    }

    &__description {
        color: var(--color-white);
        font-size: 1.3vw;
        padding-right: 30%;
        margin-top: 2em;
        position: relative;
        z-index: 2;

        @media (--viewport-tablet) {
            margin-top: 1.5em;
            font-size: 14px;
            padding-right: 0;
        }

        &-letter {
            display: inline-block;
            padding-right: 0.5em;
        }
    }
}

/* .btn-part {
    color: #fff;
    text-align: left;
    transition: opacity 0.5s ease;
    @media (--viewport-tablet) {
        font-family: var(--font-main);
        font-size: 11.5px;
        text-transform: uppercase;
        font-weight: bold;
    }
    &_next {
        width: 174px;
        margin-left: auto;
        @media (--viewport-tablet) {
            width: auto;
        }
    }
    &-wrp {
        pointer-events: all;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: relative;
        z-index: 2;
        opacity: 0;
        transition: 1s;
        transition-delay: 1s;
        margin-top: 28px;
        @media (--viewport-tablet) {
            margin-top: 14vh;
            padding: 0 var(--grid-column-mobile);
        }
    }
    &_announce {
        display: block;
        font-family: var(--font-main);
        font-size: 0.75rem;
        text-transform: uppercase;
        font-weight: bold;
        margin-top: 10px;
        @media (--viewport-tablet) {
            font-size: 9px;
        }
    }
}



.section {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    &__image-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__image-grid-container {
        position: relative;
        width: var(--grid-width);
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        @media (--viewport-laptop) {
            width: 100%;
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__image-container {
        width: calc(var(--grid-column) * 18);
        height: calc((var(--grid-column) * 18) * (439 / 876));
        overflow: hidden;

        @media (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 18);
            height: calc((var(--grid-column-laptop) * 18) * (439 / 876));
        }

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            height: 70vh;
        }
    }

    &__image {
        width: 100%;
        height: auto;
        transform: translateX(101%);

        @media (--viewport-tablet) {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
    &__text-btn-cnt {
        position: relative;
        width: calc(50vw + var(--grid-width) / 2);
        margin-left: auto;
        color: white;
        font-family: var(--font-accent);
        //font-size: 6.6666rem;
        line-height: 1.2;
        pointer-events: none;
        padding-right: 0;
        @media (--viewport-laptop) {
            width: 100%;
            padding: 77px 0 0 var(--grid-column-laptop);
        }
        @media (--viewport-tablet) {
            width: auto;
            height: auto;
            padding-top: 0px;
            top: 77px;
            padding-left: 0;
            padding-right: 0;
        }
    }
    &__text-wrapper {
        position: relative;
        display: block;
        z-index: 20;
        //width: var(--grid-width);
        // margin: 0 auto;
        padding-top: 77px;
        pointer-events: none;
        &.active {
            pointer-events: all;
        }
        @media (--viewport-laptop) {
            // width: 100%;
            // padding: 77px var(--grid-column-laptop) 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            // width: auto;
            // height: auto;
            // padding-top: 0px;
            // top: 77px;
        }
    }

    &.active {
        .section__text-wrapper {
            pointer-events: all;
        }
    }

    &__text-block {
        position: relative;
        display: block;
        overflow: hidden;
    }

    &__text {
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: cover;
        transform: translateY(150%);

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }

    &__text--white {
        position: absolute;
        left: 0;
        // top: -11px;
        top: 0;
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        opacity: 0;
        z-index: 10;

        @media (--viewport-tablet) {
            // top: -8%;
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}
.wire {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    opacity: 0;

    &__item {
        position: absolute;
        width: 100%;
        height: 100%;
        pointer-events: none;
        &-bg {
            display: inline-block;
            background: black;
            position: absolute;
            width: 100%;
            height: 100%;
            transform-origin: 0% 0;
            z-index: 18;
        }

        svg {
            position: absolute;
            height: auto;
            z-index: 17;
        }

        &:nth-child(1) {
            svg {
                width: 30vw;
                @media (--viewport-tablet) {
                    width: 70%;
                }
            }
        }

        &:nth-child(2) {
            svg {
                width: 30vw;
                bottom: 0;
                @media (--viewport-tablet) {
                    width: 70%;
                }
            }
        }

        &:nth-child(3) {
            svg {
                width: 70vw;
                height: 47vw;
                bottom: 0;
                right: 0;

                @media (--viewport-tablet) {
                    display: none;
                }
            }
        }
    }
}
.barbwire {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    opacity: 0;

    &__item {
        position: relative;
        width: 100%;
        height: 50%;
        pointer-events: none;

        &-bg {
            display: inline-block;
            background: black;
            position: absolute;
            width: 100%;
            height: 100%;
            transform-origin: 0% 0;
            z-index: 16;
        }

        svg {
            width: 100%;
            height: auto;
        }

        &:nth-child(2) {
            svg {
                position: relative;
                z-index: 15;
            }
        }
    }
}
.chain {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    opacity: 0;

    &__item {
        position: relative;
        width: 100%;
        height: 50%;
        pointer-events: none;

        &-bg {
            display: inline-block;
            background: black;
            position: absolute;
            width: 100%;
            height: 100%;
            transform-origin: 0% 0;
            z-index: 16;
        }

        svg {
            width: 100%;
            height: auto;
        }

        &:nth-child(1) {
            text-align: right;

            svg {
                width: 50%;
                @media (--viewport-tablet) {
                    width: 100%;
                }
            }
        }

        &:nth-child(2) {
            text-align: left;
            svg {
                width: 50%;
                position: relative;
                z-index: 15;
                @media (--viewport-tablet) {
                    width: 100%;
                }
            }
        }
    }
} */
</style>
